import React from 'react';
import { CTABlock } from './CTABlock';
export function HeroSection() {
  return <section className="bg-forest-900 text-forest-50 pt-16 pb-16 px-4 md:pt-20 md:pb-24" data-id="element-58">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-59">
        <div className="space-y-8 text-center md:text-left" data-id="element-60">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-61">
            Silenciá tu panza inflada para siempre en 14 días...{' '}
            <span className="text-gold-400 block mt-2" data-id="element-62">
              comiendo en cualquier feria o super de Argentina.
            </span>
          </h1>

          {/* Mockup - visible only on mobile, between title and subtitle */}
          <div className="flex justify-center md:hidden" data-id="element-63">
            <img src="https://cdn.magicpatterns.com/uploads/kmBF8BGQSmD2oe98MTikBc/Mockup_-_Oferta_N11.png" alt="Protocolo Rescate SIBO Mockup" className="w-full max-w-sm drop-shadow-2xl animate-fade-in-up" data-id="element-64" />
          </div>

          <p className="text-2xl font-bold text-white leading-relaxed" data-id="element-65">
            Sin antibióticos. Sin dietas imposibles. Sin adivinar qué te hace
            mal.
          </p>

          <p className="text-lg md:text-xl text-forest-50/90 leading-relaxed italic" data-id="element-66">
            El primer protocolo de nutrición vegetal funcional diseñado
            específicamente para la mujer argentina con SIBO — con alimentos que
            ya conocés, a precios que ya podés pagar.
          </p>

          <div className="pt-4 flex justify-center md:justify-start" data-id="element-67">
            <CTABlock className="w-full md:w-auto text-lg" data-id="element-68">
              QUIERO EL PROTOCOLO COMPLETO →
            </CTABlock>
          </div>
        </div>

        {/* Mockup - visible only on desktop */}
        <div className="hidden md:flex justify-center" data-id="element-69">
          <img src="https://cdn.magicpatterns.com/uploads/kmBF8BGQSmD2oe98MTikBc/Mockup_-_Oferta_N11.png" alt="Protocolo Rescate SIBO Mockup" className="w-full max-w-full drop-shadow-2xl animate-fade-in-up" data-id="element-70" />
        </div>
      </div>
    </section>;
}